"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCard = EventCard;
exports.EventCardSkeleton = EventCardSkeleton;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var tokens_1 = require("../../tokens");
var GlassCard_1 = require("../GlassCard");
var Icons_1 = require("../Icons");
// 画像の高さ(px)。EventCard本体とSkeletonで寸法がズレないよう共通の定数にする。
// Figma仕様の3:2(280×186.67)に合わせる
var IMAGE_HEIGHT = 187;
function EventCard(_a) {
    var imageUrl = _a.imageUrl, title = _a.title, categoryLabel = _a.categoryLabel, categoryColor = _a.categoryColor, categoryBgColor = _a.categoryBgColor, dateLabel = _a.dateLabel, locationLabel = _a.locationLabel, href = _a.href, onClick = _a.onClick, sx = _a.sx;
    return ((0, jsx_runtime_1.jsx)(GlassCard_1.GlassCard, { bordered: false, cornerRadius: 8, highlight: true, sx: sx, children: (0, jsx_runtime_1.jsxs)(material_1.CardActionArea, { href: href !== null && href !== void 0 ? href : '', onClick: onClick, sx: { height: '100%', position: 'relative' }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        height: "".concat(IMAGE_HEIGHT, "px"),
                        backgroundImage: "url(".concat(imageUrl, ")"),
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    } }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { p: 4 }, spacing: 2, children: [categoryLabel && ((0, jsx_runtime_1.jsx)(material_1.Chip, { size: "small", sx: {
                                height: 20,
                                borderRadius: '2px',
                                minWidth: 40,
                                alignSelf: 'flex-start',
                                bgcolor: categoryBgColor,
                                '.MuiChip-label': { px: '6px', py: '2px' },
                            }, label: (0, jsx_runtime_1.jsx)(material_1.Typography, { color: categoryColor, display: "block", sx: {
                                    fontSize: 12,
                                    fontWeight: 600,
                                    lineHeight: '16px',
                                    letterSpacing: 0,
                                }, children: categoryLabel }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: '20px',
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                overflow: 'hidden',
                                overflowWrap: 'anywhere',
                            }, children: title }), dateLabel && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 1, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(Icons_1.CalendarIcon, { sx: { fontSize: 16, color: 'grey.700' } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "overline", color: "text.secondary", children: dateLabel })] })), locationLabel && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 1, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(Icons_1.MapPinIcon, { sx: { fontSize: 16, color: 'grey.700' } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "overline", color: "text.secondary", sx: { overflowWrap: 'anywhere' }, children: locationLabel })] }))] })] }) }));
}
function EventCardSkeleton(_a) {
    var width = _a.width, sx = _a.sx;
    return ((0, jsx_runtime_1.jsxs)(material_1.Card, { sx: __assign({ borderRadius: "".concat(tokens_1.radius.md, "px"), width: width }, sx), children: [(0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "rectangular", sx: { height: "".concat(IMAGE_HEIGHT, "px") } }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { p: 4 }, spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "30%" }), (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "100%" }), (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "60%" })] })] }));
}
